import { Link } from "react-router-dom";
import type { Work } from "@/types/media";
import { TYPE_LABELS } from "@/types/media";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={work.title}
          title={`${work.title} 影视作品封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          {TYPE_LABELS[work.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span>{work.region}</span>
        </div>
        <div className="flex flex-wrap gap-1">
          {work.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}